import styled from 'styled-components';

export const ShopContainer = styled.div`
	position: absolute;
	top: 80px;
	left: 80px;
	width: 442px;
	height: 840px;
	padding: 30px;
	border-radius: 10px;
	background-color: rgba(17, 19, 20, 0.98);
	border: 1px solid rgba(255, 255, 255, 0.1);
	transition: opacity 0.3s ease;
`;

export const ShopCategoriesGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-auto-rows: 120px;
	gap: 10px;
	width: 100%;
`;

export const ShopCloseButtonContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	border-radius: 10px;
	background-color: #111314;
	cursor: pointer;
	transition: background-color 0.3s ease;

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}

	img {
		transition: filter 0.3s ease;
		pointer-events: none;
		user-select: none;
	}
`;
